import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_AcknowledgementFreedomChoice = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_AcknowledgementFreedomChoice' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Lily Pad Home Health Care,LLC.</h3></p>
                <p className='w-750'><h3>Acknowledgement of Freedom of Choice</h3></p>

                <p className='w-750'>
                    I &nbsp;
                    <input type='text' id='txtName' name='txtName' className='add-only w-250 custom-add-only' /> &nbsp;
                    have voluntarily enrolled in Adult Day Services with Lily Pad of Mississippi. Furthermore , I understand that I 
                    have the right to select the provider of my choice. I have, of my own free will, selected Lily Pad of Mississippi as my Adult Day Services Provider.
                </p>


            </div>
        </form >

    )
}











